module.exports = __webpack_public_path__ + "f5a81ee986e74eb30bcf1df4c2790043.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/branding/logo.svg
// module id = 899
// module chunks = 0